import React, { useState } from 'react';
import { withProps } from 'recompose';
import get from 'lodash/get';
import { RouterlessModal } from '@/se/components/Modal';
import { breakpoint } from '@/se/utilities/responsive';
import { useMutation, useQuery } from '@apollo/client';
import ObjectInput from '@/se/components/inputs/ObjectInput';
import Form from '@/se/components/Form';
import { getScheduleNotificationConfiguration, updateScheduleNotificationConfig } from '../../../../graph/procedures';
import { CenteredSpinner } from '@/se/components/Spinner';
import { withLabel } from '@/se/components/Label';
import { compact } from 'lodash/array';
import NotificationRecipients from './NotificationRecipients';
import IconButton from '@material-ui/core/IconButton';
import SettingsIcon from '@material-ui/icons/Settings';

const ScheduleNotificationConfigInput = withProps({
  schema: {
    notificationRecipients: withLabel('Schedule Update Notification Recipients')(NotificationRecipients),
  },
})(ObjectInput);

const ScheduleNotificationDialog = ({ style }) => {
  const [open, setOpen] = useState(false);

  // Replace deprecated Query component with useQuery hook
  const { loading, data = {} } = useQuery(getScheduleNotificationConfiguration);

  const [mutate] = useMutation(updateScheduleNotificationConfig);

  const handleSubmit = async values => {
    const result = await mutate({
      variables: {
        notificationRecipients: compact(get(values, 'notificationRecipients', [])),
      },
      refetchQueries: [{ query: getScheduleNotificationConfiguration }],
    });

    if (get(result, 'data.updateScheduleNotificationConfig')) {
      setOpen(false);
    }
  };

  const mapInput = (val = {}) => ({
    ...val,
  });

  return (
    <div>
      <IconButton onClick={() => setOpen(true)} style={style}>
        <SettingsIcon />
      </IconButton>
      {open && (
        <RouterlessModal
          title={'Schedule Notification Configuration'}
          onClose={() => setOpen(false)}
          fullWindow={window.innerWidth < breakpoint.md}
        >
          {!loading ? (
            <Form
              autoFocus
              initialValue={mapInput(get(data, 'scheduleNotificationConfiguration'))}
              input={ScheduleNotificationConfigInput}
              label={'Save'}
              onSubmit={handleSubmit}
              onCancel={() => setOpen(false)}
            />
          ) : (
            <CenteredSpinner />
          )}
        </RouterlessModal>
      )}
    </div>
  );
};

export default ScheduleNotificationDialog;
